import type { ContactUsFormCopy, ResolvedContactUsFormCopy } from "./types";

/**
 * Defaults are the live SFRA strings (`org_hec/cartridge/client/default/js/
 * contactUs/contactUs.js:121-138`, read 2026-10-13). The success line is the
 * COM-735 acceptance-criteria copy, verbatim.
 */
export const DEFAULT_SUBMIT_LABEL = "Submit";
export const DEFAULT_SUCCESS_MESSAGE =
  "Sent! A Customer service representative will reach out to you shortly.";
export const DEFAULT_FAILURE_MESSAGE =
  "Due to some difficulties we couldn't process your request. Please try again.";

const pick = (value: string | undefined, fallback: string): string =>
  value !== undefined && value.trim() !== "" ? value : fallback;

export function resolveContactUsFormCopy(
  copy: ContactUsFormCopy | undefined,
): ResolvedContactUsFormCopy {
  return {
    submitLabel: pick(copy?.submitLabel, DEFAULT_SUBMIT_LABEL),
    successMessage: pick(copy?.successMessage, DEFAULT_SUCCESS_MESSAGE),
    failureMessage: pick(copy?.failureMessage, DEFAULT_FAILURE_MESSAGE),
  };
}
